const AUTH_TOKEN = 'authToken';

const ROUTES = {
  AUTH: {
    LOGIN: '/login',
    LOGOUT: '/logout',
    REGISTER: '/register',
    REGISTER_IFRAME: '/register-iframe',
    FORGOT_PASSWORD: '/forgot-password',
    RECOVER_PASSWORD: '/recover-password',
    EVENT_INVITE: '/invite/event',
  },
  ROOT: '/',
  COCKPIT: 'cockpit',
  FINANCIAL_MANAGEMENT: 'business-management/financial-management',
  COMMERCIAL_MANAGEMENT: 'business-management/commercial-management',
  DIGITAL_MARKETING: 'business-management/digital-marketing',
  CLUB_ACTIVATION_ROUNDS: 'club/activation-rounds',
  COMMUNITY_PROFILE: 'community-profile',
  COMMUNITY_GENERAL_PROFILE: 'community/intelligence-networking/general-profile',
  COMMUNITY_BIO: 'community/intelligence-networking/bio',
  COMMUNITY_INDIVIDUAL_NETWORK: 'community/intelligence-networking/individual_network',
  CLUB_BIO: 'community/intelligence-connections/bio',
  INTELLIGENCE_NETWORKING: 'intelligence-networking',
  THEMATIC_GROUPS: 'thematic-groups',
  DIGITAL_GOVERNANCE: 'digital-governance',
  USER: {
    PROFILE: 'user-profile',
    SETTINGS: 'settings/profile',
    PROFILE_MOBILE: 'user-profile/profile',
    PROFILE_MOBILE_SELF_ASSESSMENT: 'user-profile/self-assessment',
    PROFILE_MOBILE_CHALLENGES_AND_PROJECTS_2025: 'user-profile/challenges-and-projects-2025',
    PROFILE_FEEDBACK_NETWORK_EXPERIENCE: 'user-profile/feedback-networking-experience',
    PROFILE_INVITES: 'user-profile/invites',
  },
  EDUCATION: {
    SHOWCASE: 'education/vitrine',
    MY_COURSES: 'education/my-courses',
    FAVORITES: 'education/favorites',
    ORCHESTRATOR: 'education/orchestrator',
    SUB_ORCHESTRATOR: {
      CATEGORY: 'education/orchestrator/category',
      COURSES: 'education/orchestrator/courses',
      LESSONS: 'education/orchestrator/lessons',
    },
  },
  TEST: {
    SECOND_LEVEL: {
      THIRD_LEVEL_1: 'community/teste/terceiro-nivel',
      THIRD_LEVEL_2: '/community/2-nv-2/2-nv-1',
    },
  },
  NOT_FOUND: 'not-found',
  ATIVACAO_PRESENCIAL: 'networking-exp/ativacao-presencial',
};

const POSITIVE = 'positive';
const NEGATIVE = 'negative';
const ALL = 'all';

export { AUTH_TOKEN, ROUTES, POSITIVE, NEGATIVE, ALL };
